import type { APP_USER_ROLES } from '@/types';
import { useCurrentUser } from './use-current-user.query';

export const useUserRole = () => {
  const { data: user } = useCurrentUser();

  return user ? (user.role as APP_USER_ROLES) : null;
};
